export class Voice {
    constructor(ctx, destination) {
        this.ctx = ctx;
        this.destination = destination;
        
        this.osc = this.ctx.createOscillator();
        this.vca = this.ctx.createGain();
        
        this.osc.connect(this.vca);
        this.vca.connect(this.destination);
        
        // Defaults
        this.osc.type = 'sawtooth';
        this.osc.frequency.value = 440;
        this.vca.gain.value = 0;
        
        this.osc.start();
        
        this.active = false;
        this.id = null; // Touch ID or Note ID
    }

    setWaveform(type, customWave) {
        if (customWave) {
            this.osc.setPeriodicWave(customWave);
        } else {
            this.osc.type = type;
        }
    }

    triggerAttack(freq, maxGain = 0.5, id = null, time = null) {
        this.active = true;
        this.id = id;
        
        const now = time || this.ctx.currentTime;

        if (freq) this.setPitch(freq, now);
        
        this.vca.gain.cancelScheduledValues(now);
        this.vca.gain.setValueAtTime(this.vca.gain.value, now);
        this.vca.gain.linearRampToValueAtTime(maxGain, now + 0.01);
    }

    setPitch(freq, time = null) {
        const now = time || this.ctx.currentTime;
        this.osc.frequency.cancelScheduledValues(now);
        this.osc.frequency.setTargetAtTime(freq, now, 0.01);
    }

    triggerRelease(time = null) {
        this.active = false;
        this.id = null;
        
        const now = time || this.ctx.currentTime;
        this.vca.gain.cancelScheduledValues(now);
        this.vca.gain.setValueAtTime(this.vca.gain.value, now);
        this.vca.gain.exponentialRampToValueAtTime(0.001, now + 0.2);
        this.vca.gain.linearRampToValueAtTime(0, now + 0.22); // Ensure silence
        // We don't stop the oscillator, we just silence it to keep the pool ready
    }
}
